import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { i18nResolver } from 'src/app/core/resolvers';
import { userBeanReportingResolver } from './resolvers/user-bean.resolver';

export const reportingRoutes: Routes = [
  {
    path: 'reporting',
    title: 'WEB_REPORTING_AAA',
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanReportingResolver,
    },
    loadComponent: () =>
      import('./pages/reporting.component').then((m) => m.ReportingComponent),
    data: { navigationRoute: ROUTE_NAMES.REPORTING },
  },
];
